import { Email as EmailIcon } from "@mui/icons-material";
import type { FC } from "react";
import AsyncLoadingButton from "../../components/asyncLoadingButton/AsyncLoadingButton";
import { useCustomerEmails } from "./useCustomerEmails";

const SendCheckInButton: FC<{ orderId: string }> = ({ orderId }) => {
  const { sendEmail } = useCustomerEmails(orderId);
  return (
    <AsyncLoadingButton
      startIcon={<EmailIcon />}
      variant="outlined"
      color="secondary"
      onClick={async () => {
        await sendEmail("CHECK_IN");
      }}
    >
      Wyślij odprawę
    </AsyncLoadingButton>
  );
};

export default SendCheckInButton;
